module.exports = __webpack_public_path__ + "img/swiper2.ef07db51.png";